import { TableCell, TableRow } from "@mui/material";

import { useCraneDriver } from "../CraneDriverProvider";

interface CraneTableSequenceLabelRowProps {
  label: string;
}

export const CraneTableSequenceLabelRow = ({
  label,
}: CraneTableSequenceLabelRowProps) => {
  const { assignedLoads } = useCraneDriver();

  return (
    <TableRow>
      <TableCell
        colSpan={assignedLoads.length + 1}
        sx={{
          py: 0.25,
          border: 0,
          color: "text.disabled",
          textTransform: "uppercase",
          letterSpacing: 0.5,
          fontWeight: "bold",
          fontSize: { xs: 12, md: 14, lg: 16 },
        }}
      >
        {label}
      </TableCell>
    </TableRow>
  );
};
